import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import emailjs from "emailjs-com";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    service: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
  e.preventDefault();
  setIsSubmitting(true);

  emailjs.send(
    "service_ght7hfk",
    "template_fji6d16",
    {
      user_name: formData.name,
      user_email: formData.email,
      phone: formData.phone,
      company: formData.company,
      service: formData.service,
      message: formData.message,
    },
    "-XPJBf2qj-HMAxcv0"
  )
  .then(() => {
    alert('Thank you for your message! We will get back to you soon.');

    setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        service: '',
        message: ''
      });

      setIsSubmitting(false);
  })
  .catch((error) => {
    console.log(error);
    alert("Failed to send message");
    setIsSubmitting(false);
  });
};

const services = [
    'Cybersecurity',
    'Cloud Services',
    'Web Development',
    'SEO & Digital Marketing',
    'Mobile Apps & Software',
    'Hosting & Domains',
    'Other'
  ];

  return (
    <section id="contact" className="py-16 px-6 bg-netbernet-white">
      <div className="container mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-netbernet-black mb-4">Get In Touch</h2>
          <p className="text-xl text-gray-600">Have a project in mind? Let's discuss how we can help</p>
        </div>
        
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 pl-6">
          <div>
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="name" className="block text-gray-700 font-medium mb-2">Full Name *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="Your full name"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="your@email.com"
                    />
                  </div>
                </div>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="+91 12345 67890"
                    />
                  </div>
                  <div>
                    <label htmlFor="company" className="block text-gray-700 font-medium mb-2">Company Name</label>
                    <input
                      type="text"
                      id="company"
                      name="company"
                      value={formData.company}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                      placeholder="Your company"
                    />
                  </div>
                </div>

                <div>
                  <label htmlFor="service" className="block text-gray-700 font-medium mb-2">Service Required</label>
                  <select
                    id="service"
                    name="service"
                    value={formData.service}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors"
                  >
                    <option value="">Select a service</option>
                    {services.map((service, index) => (
                      <option key={index} value={service}>{service}</option>
                    ))}
                  </select>
                </div>

                <div>
                  <label htmlFor="message" className="block text-gray-700 font-medium mb-2">Message *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows="5"
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-netbernet-blue focus:border-netbernet-blue transition-colors resize-vertical"
                    placeholder="Tell us about your project requirements..."
                  ></textarea>
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full bg-netbernet-blue text-netbernet-white px-6 py-4 rounded-lg font-semibold hover:bg-blue-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? 'Sending...' : 'Send Message'}
                </button>
            </form>
          </div>
          
          <div className="space-y-8 pl-16">
            <div className="flex items-start">
              <div className="bg-netbernet-blue p-3 rounded-full mr-4">
                <FaMapMarkerAlt className="text-netbernet-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Address</h3>
                <p className="text-gray-600">Ring Road, Pillar No. 102, Attapur,</p>
                <p className="text-gray-600">Hyderabad - 500006, Telangana, India</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-netbernet-blue p-3 rounded-full mr-4">
                <FaPhone className="text-netbernet-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Phone</h3>
                <p className="text-gray-600">+91 630 131 5362 / +91 40 45126535</p>
              </div>
            </div>
            
            <div className="flex items-start">
              <div className="bg-netbernet-blue p-3 rounded-full mr-4">
                <FaEnvelope className="text-netbernet-white" />
              </div>
              <div>
                <h3 className="text-xl font-semibold mb-2">Email</h3>
                <p className="text-gray-600">info@netbernet.com</p>
              </div>
            </div>
            
            <div className="pt-4">
              <h3 className="text-xl font-semibold mb-4">Business Hours</h3>
              <p className="text-gray-600">Monday - Saturday: 10:00 AM - 7:00 PM</p>
              <p className="text-gray-600">Sunday: Closed</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;